import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Gps } from 'src/app/shared/gps';
import { Geoutil } from 'src/app/shared/geoutil';

@Component({
  selector: 'app-followme',
  templateUrl: './followme.component.html',
  styleUrls: ['./followme.component.css']
})
export class FollowmeComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {};
  google_map: Google_map;
  gps: Gps;
  counter = 0;
  origin: any = {};
  polygons: any = [];
  polygondefs: any = [
    { id: 1, radius: 200, val: 10, color: "#AF9659" },
    { id: 2, radius: 100, val: 20, color: "#CBA23D" },
    { id: 3, radius: 50, val: 40, color: "#DD912B" },
    { id: 4, radius: 20, val: 60, color: "#E96C1F" },
    { id: 5, radius: 10, val: 80, color: "#F15A17" },
    { id: 6, radius: 2, val: 100, color: "#FF0909" },
  ];
  polydef = {id:0,value:0};

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
    this.gps = new Gps();
  }
  
  async initMap() {
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);

    this.origin = data;
    //this.origin = latlng;
    this.google_map = new Google_map();
    this.google_map.init(this.mapElement.nativeElement, this.origin, 17);
    this.google_map.setMarker(this.origin, "My current location");

    this.polygondefs.forEach((pd: any) => {
      let poly = Geoutil.getCircleArray(this.origin, pd.radius, 24);
      this.polygons.push(poly);
    });
    this.polygons.forEach((poly: any, index: number) => {
      let color = this.polygondefs[index].color
      poly.push(poly[0]);
      this.google_map.addPolygon(poly, color);
    })

    this.gps.updateLocation(this.updateLocationCallback.bind(this)); //callbacks need a bind
  }

  updateLocationCallback(latlng: any) {
    this.counter++;
    this.google_map.addCircle(latlng, 2, "#0909FF");
    let distance = Geoutil.getDistance(this.origin, latlng);
    this.polydef = {id:0,value:0};

    for (let i = 0; i < this.polygons.length; i++) {
      let isInPoly = Geoutil.pointInPolygon(this.polygons[i], latlng);
      if (isInPoly) this.polydef = this.polygondefs[i];
    }

    this.alert.success("Counter: " + this.counter + ", Distance " + distance.toFixed(1) + " meter; In Poly: " + this.polydef.id + "; Value: " + this.polydef.value);
  }

}
